export function initColumGridWithHoverSlider() {
  if (typeof Swiper === "undefined") {
    return;
  }

  const sectionNodes = document.querySelectorAll(".js-column-grid-with-hover");
  if (!sectionNodes.length) {
    return;
  }

  const mobileQuery = window.matchMedia("(max-width: 768px)");
  let resizeDebounceId = null;

  const controllers = Array.from(sectionNodes).map((sectionEl) => {
    const sliderEl = sectionEl.querySelector(".column-grid-with-hover__slider");
    const btnPrev = sectionEl.querySelector(".column-grid-with-hover__nav-btn--prev");
    const btnNext = sectionEl.querySelector(".column-grid-with-hover__nav-btn--next");

    let swiperInstance = null;

    const equalizeCardHeights = () => {
      const cards = sectionEl.querySelectorAll(".column-grid-with-hover__card");
      if (!cards.length) {
        return;
      }

      cards.forEach((card) => {
        card.style.minHeight = "";
        card.style.height = "";
      });

      window.requestAnimationFrame(() => {
        let maxHeight = 0;
        cards.forEach((card) => {
          maxHeight = Math.max(maxHeight, card.getBoundingClientRect().height);
        });

        const target = Math.ceil(maxHeight);
        if (target <= 0) {
          return;
        }

        cards.forEach((card) => {
          card.style.minHeight = `${target}px`;
        });

        if (swiperInstance) {
          swiperInstance.update();
        }
      });
    };

    const initSwiper = () => {
      if (!sliderEl || swiperInstance) {
        return;
      }

      swiperInstance = new Swiper(sliderEl, {
        slidesPerView: 1.08,
        spaceBetween: 10,
        watchOverflow: true,
        centeredSlides: true,
        loop: false,
        navigation:
          btnPrev && btnNext
            ? {
                prevEl: btnPrev,
                nextEl: btnNext,
              }
            : undefined,
      });
    };

    const destroySwiper = () => {
      if (!swiperInstance) {
        return;
      }

      swiperInstance.destroy(true, true);
      swiperInstance = null;
    };

    sectionEl.querySelectorAll(".column-grid-with-hover__card img").forEach((img) => {
      if (!img.complete) {
        img.addEventListener("load", equalizeCardHeights, { once: true });
      }
    });

    return { initSwiper, destroySwiper, equalizeCardHeights };
  });

  const syncViewports = () => {
    controllers.forEach((c) => {
      if (mobileQuery.matches) {
        c.initSwiper();
      } else {
        c.destroySwiper();
      }
      c.equalizeCardHeights();
    });
  };

  const scheduleResizeEqualize = () => {
    window.clearTimeout(resizeDebounceId);
    resizeDebounceId = window.setTimeout(() => {
      controllers.forEach((c) => c.equalizeCardHeights());
    }, 150);
  };

  syncViewports();

  window.addEventListener("resize", scheduleResizeEqualize);

  if (typeof mobileQuery.addEventListener === "function") {
    mobileQuery.addEventListener("change", syncViewports);
  } else {
    mobileQuery.addListener(syncViewports);
  }
}
